import React, { useState, useEffect } from "react";
import { producaov2 } from "../../../services/apis";
import { Button, Modal, Table } from "semantic-ui-react";
import {
  ActionButtons,
  AddModuloModalContainer,
  Bottom,
  ButtonsWrapper,
  Container,
  ModalActions,
  ModalContainer,
  ModuloHeader,
  NumberInput,
  TitleInput,
} from "./styles";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { RiDeleteBinLine } from "react-icons/ri";
import CursosSelector from "../CursosSelector";
import Back from "../Back";

export const MBAListOnePersist = props => {
  const [mba, setMba] = useState([]);
  const [descricao, setDescricao] = useState(mba.descricao);
  const [idCombo, setIdCombo] = useState("");
  const [idCurso, setIdCurso] = useState("");
  const [modalModuloId, setModalModuloId] = useState(null);
  const [isAddModuloOpen, setIsAddModuloOpen] = useState(false);
  const [selectedModalCourse, setSelectedModalCourse] = useState(0);
  const [selectedModalCourseName, setSelectedModalCourseName] = useState(0);
  const [addModuloModalTitulo, setAddModuloModalTitulo] = useState([]);
  const [addModuloModalDate, setAddModuloModalDate] = useState([]);
  const [isAddLiveModalOpen, setIsAddLiveModelOpen] = useState();
  const [addLiveDescricao, setAddLiveDescricao] = useState("");
  const [addLiveLink, setAddLiveLink] = useState("");
  const [addLiveDate, setAddLiveDate] = useState("");
  const [addLiveTipo, setAddLiveTipo] = useState("");

  const id = props.match.params.id;

  const loadMba = () => {
    producaov2.get(`/admin/mba/${id}`).then(response => setMba(response.data));
  };

  useEffect(() => {
    setDescricao(mba.descricao);
    setIdCombo(mba.id_combo);
    setIdCurso(mba.id_curso);
  }, [mba]);

  useEffect(() => {
    loadMba();
  }, [id]);

  //atualizar modulo
  const handleAtualizarOrdemCursos = async moduloId => {
    const cursos = mba.mbaModulos.find(
      modulo => modulo.id === moduloId
    ).moduloCursos;
    const formatedCursos = cursos
      .sort((a, b) => a.order - b.order)
      .map(curso => curso.id_curso);

    const moduloName = mba.mbaModulos.find(
      modulo => modulo.id === moduloId
    ).titulo;

    producaov2.put(`/admin/mba/add-courses-modulo-general/${moduloId}`, {
      cursos: formatedCursos,
      title: moduloName,
    });
  };

  const handleAtualizarModulo = async moduloId => {
    const modulo = mba.mbaModulos.find(modulo => modulo.id === moduloId);

    return producaov2
      .put(`/admin/mba/att-modulo/${modulo.id}`, {
        titulo: modulo.titulo,
        data_liberacao: modulo.data_liberacao,
      })
      .catch(error => {
        throw error;
      });
  };

  const handleAtulizarModuloGeral = async moduloId => {
    Promise.all([
      handleAtualizarOrdemCursos(moduloId),
      handleAtualizarModulo(moduloId),
    ])
      .then(() => {
        swal("Módulo Alterado", "", "success");
      })
      .catch(() => swal("Houve um erro ao atualizar o módulo", "", "error"));
  };

  //atualizar MBA inteiro
  const handleAtualizarOrdemModulos = async () => {
    const orders = mba.mbaModulos
      .sort((a, b) => a.order - b.order)
      .map(modulo => modulo.id);

    return producaov2
      .put("/admin/mba/change-modulos-order", {
        id_mba: id,
        orders,
      })
      .catch(error => {
        throw error;
      });
  };

  const handleAtualizarInfoMBA = async () => {
    return producaov2
      .put(`/admin/mba/att-mba/${id}`, {
        descricao,
        id_combo: idCombo,
        id_curso: idCurso,
      })
      .catch(error => {
        throw error;
      });
  };

  const handleAtualizarMBA = () => {
    Promise.all([handleAtualizarOrdemModulos(), handleAtualizarInfoMBA()])
      .then(() => {
        loadMba();
        swal("MBA Atualizado com sucesso", "", "success");
      })
      .catch(() => {
        swal("Erro ao atualizar MBA", "", "error");
      });
  };

  const handleChangeDataLiberacao = (moduloId, value) => {
    const copyMBA = { ...mba };

    copyMBA.mbaModulos.find(modulo => modulo.id === moduloId).data_liberacao =
      value;

    setMba(copyMBA);
  };

  const handleCursosOrdemChange = (idModulo, idCurso, value) => {
    const updatedMba = { ...mba };

    updatedMba.mbaModulos
      .find(modulo => modulo.id === idModulo)
      .moduloCursos.find(curso => curso.id_curso === idCurso).order = value;

    setMba(updatedMba);
  };

  const handleModuloOrdemChange = (moduloId, value) => {
    const updatedMba = { ...mba };

    updatedMba.mbaModulos.find(modulo => modulo.id === moduloId).order = value;

    setMba(updatedMba);
  };

  const handleTitleChange = (value, moduloId) => {
    console.log({ value });
    const updatedMba = { ...mba };

    updatedMba.mbaModulos.find(modulo => modulo.id === moduloId).titulo = value;

    setMba(updatedMba);
  };

  const handleRemoveCourse = (id_modulo, id_course) => {
    const updatedMba = { ...mba };

    console.log({ updatedMba });

    const updatedModuloCursos = updatedMba.mbaModulos
      .find(modulo => modulo.id === id_modulo)
      .moduloCursos.filter(curso => curso.id_curso !== id_course);

    updatedMba.mbaModulos.find(modulo => modulo.id === id_modulo).moduloCursos =
      updatedModuloCursos;

    setMba(updatedMba);
  };

  const handleCloseModal = () => {
    setSelectedModalCourse(0);
    setModalModuloId(null);
  };

  const handleAdicionarCurso = (value, text) => {
    const updatedMba = { ...mba };

    const cursos = mba.mbaModulos.find(
      modulo => modulo.id === modalModuloId
    ).moduloCursos;

    updatedMba.mbaModulos
      .find(modulo => modulo.id === modalModuloId)
      .moduloCursos.push({
        id: value,
        id_modulo: modalModuloId,
        id_curso: value,
        order: cursos[cursos.length - 1].order + 1,
        curso: {
          curso: text,
        },
      });

    setModalModuloId(0);
    setSelectedModalCourse(0);
    setSelectedModalCourseName("");

    setMba(updatedMba);
  };

  const handleRemoveModulo = id_modulo => {
    producaov2
      .delete(`/admin/mba/remove-modulo/${id_modulo}`)
      .then(() => {
        swal("Módulo deletado", "", "success");
        loadMba();
      })
      .catch(() => {
        swal("Erro ao deletar módulo", "", "error");
      });
  };

  const handleAddModulo = () => {
    const userId = mba?.id_pessoa;

    const payload = {
      id_mba: id,
      titulo: addModuloModalTitulo,
      data_liberaca: addModuloModalDate,
    };

    if (userId) {
      payload.user_id = userId;
    }

    producaov2.put("/admin/mba/put-modulo", payload).then(() => {
      setIsAddModuloOpen(false);
      location.reload();
    });
  };

  const formatDateToBR = date => {
    const originalDate = new Date(date);

    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };

    const brazilianDatetime = originalDate.toLocaleString("pt-BR", options);
    return brazilianDatetime;
  };

  const formatDateTime = date => {
    const originalDate = new Date(date);

    const formattedDate = `${originalDate.getFullYear()}-${(
      originalDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${originalDate
      .getDate()
      .toString()
      .padStart(2, "0")} ${originalDate
      .getHours()
      .toString()
      .padStart(2, "0")}:${originalDate
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${originalDate
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;

    return formattedDate;
  };

  const handleCloseAddLiveModal = () => {
    setAddLiveDate("");
    setAddLiveDescricao("");
    setAddLiveLink("");
    setAddLiveTipo("");
    setIsAddLiveModelOpen(false);
  };

  const handleAddLive = () => {
    if (!addLiveDate || !addLiveDate || !addLiveLink || !addLiveTipo) {
      swal("Informe todos os campos", "", "error");
    }

    producaov2
      .put("/admin/mba/vincula-live", {
        id_mba: id,
        link: addLiveLink,
        type: addLiveTipo,
        datetime: addLiveDate,
        description: addLiveDescricao,
      })
      .then(() => {
        swal("Live adicionada com sucesso", "", "success");
        loadMba();
      })
      .catch(() => {
        swal("Houve um erro ao adicionar a live", "", "error");
      });
  };

  const handleRemoveLive = live_id => {
    producaov2
      .delete(`/admin/mba/remove-live/${live_id}`)
      .then(() => {
        swal("Live removida", "", "success");
        loadMba();
      })
      .catch(() => {
        swal("Não foi possível remover a live", "", "success");
      });
  };

  return (
    <>
      <AdminMenu />
      <Container>
        <Back actualPage={"Editar"} />
        <h1>Editar MBA</h1>

        <form>
          <div>
            <label for="descricao">Descricao:</label>
            <input
              defaultValue={mba.descricao}
              id="descricao"
              onChange={evt => setDescricao(evt.currentTarget.value)}
            ></input>
          </div>

          <div>
            <label for="id_combo">ID Combo:</label>
            <input
              defaultValue={mba.id_combo}
              id="id_combo"
              type="number"
              onChange={evt => setIdCombo(evt.currentTarget.value)}
            ></input>
          </div>

          <div>
            <label for="id_curso">ID Curso:</label>
            <input
              defaultValue={mba.id_curso}
              id="id_curso"
              type="number"
              onChange={evt => setIdCurso(evt.currentTarget.value)}
            ></input>
          </div>
        </form>
        {/* <Button onClick={() => setIsAddLiveModelOpen(true)}>
          Adicionar Live
        </Button> */}

        <h2>Módulos</h2>
        {mba &&
          mba.mbaModulos &&
          mba.mbaModulos
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((modulo, moduloKey) => (
              <>
                <ModuloHeader key={modulo.id}>
                  <div>
                    <TitleInput
                      value={modulo.titulo}
                      onChange={event =>
                        handleTitleChange(event.target.value, modulo.id)
                      }
                    />

                    {/* <button onClick={() => handleRemoveModulo(modulo.id)}>
                      <RiDeleteBinLine size={16} color="#96989A" />
                    </button> */}
                  </div>

                  {/* <NumberInput
                    type="number"
                    value={modulo.order}
                    min={1}
                    onChange={(value) =>
                      handleModuloOrdemChange(modulo.id, value.target.value)
                    }
                  /> */}
                </ModuloHeader>

                <Table>
                  <Table.Header>
                    <Table.HeaderCell>ID Curso</Table.HeaderCell>
                    <Table.HeaderCell>Nome</Table.HeaderCell>
                    <Table.HeaderCell>Ordem</Table.HeaderCell>
                    <Table.HeaderCell>Ações</Table.HeaderCell>
                  </Table.Header>

                  <Table.Body>
                    {modulo.moduloCursos
                      .slice()
                      .sort((a, b) => a.order - b.order)
                      .map((curso, cursoKey) => (
                        <Table.Row key={curso.id_curso}>
                          <Table.Cell>{curso.id_curso}</Table.Cell>
                          <Table.Cell>{curso.curso.curso}</Table.Cell>
                          <Table.Cell>
                            <NumberInput
                              type="number"
                              value={curso.order}
                              min={1}
                              onChange={value =>
                                handleCursosOrdemChange(
                                  modulo.id,
                                  curso.id_curso,
                                  value.target.value
                                )
                              }
                            />
                          </Table.Cell>
                          <Table.Cell>
                            <ActionButtons>
                              <button
                                onClick={() =>
                                  handleRemoveCourse(modulo.id, curso.id_curso)
                                }
                              >
                                <RiDeleteBinLine size={16} color="#96989A" />
                              </button>
                            </ActionButtons>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
                <ButtonsWrapper>
                  <div>
                    <Button
                      onClick={() => handleAtulizarModuloGeral(modulo.id)}
                    >
                      Atualizar
                    </Button>
                    <Button onClick={() => setModalModuloId(modulo.id)}>
                      Adicionar Curso
                    </Button>
                  </div>
                  {/* <div>
                    <input
                      type="date"
                      defaultValue={modulo?.data_liberacao}
                      onChange={(evt) =>
                        handleChangeDataLiberacao(
                          modulo.id,
                          evt.currentTarget.value
                        )
                      }
                    />
                  </div> */}
                </ButtonsWrapper>
              </>
            ))}

        {/* <Bottom>
          <Button onClick={() => setIsAddModuloOpen(true)}>
            Adicionar módulo
          </Button>
          <Button positive onClick={() => handleAtualizarMBA()}>
            Atualizar
          </Button>
        </Bottom> */}

        <Modal open={!!modalModuloId} onClose={handleCloseModal}>
          <Modal.Header>Adicionar curso</Modal.Header>
          <Modal.Content>
            <ModalContainer>
              <CursosSelector
                handleChange={({ value, text }) => {
                  setSelectedModalCourse(value);
                  setSelectedModalCourseName(text);
                }}
              />
            </ModalContainer>
          </Modal.Content>
          <Modal.Actions>
            módulo
            <ModalActions>
              <Button
                positive
                onClick={() =>
                  handleAdicionarCurso(
                    selectedModalCourse,
                    selectedModalCourseName
                  )
                }
              >
                Adicionar Curso
              </Button>
              <Button onClick={handleCloseModal}>Cancelar</Button>
            </ModalActions>
          </Modal.Actions>
        </Modal>

        <Modal open={isAddModuloOpen} onClose={() => setIsAddModuloOpen(false)}>
          <Modal.Header>Adicionar módulo</Modal.Header>
          <Modal.Content>
            <AddModuloModalContainer>
              <div>
                <label>Título: </label>
                <input
                  placeholder="Título"
                  onChange={evt =>
                    setAddModuloModalTitulo(evt.currentTarget.value)
                  }
                />
              </div>
              <div>
                <label>Data liberação: </label>
                <input
                  type="date"
                  placeholder="data liberação"
                  onChange={evt =>
                    setAddModuloModalDate(evt.currentTarget.value)
                  }
                />
              </div>
            </AddModuloModalContainer>
          </Modal.Content>
          <Modal.Actions>
            <ModalActions>
              <Button positive onClick={() => handleAddModulo()}>
                Adicionar Módulo
              </Button>
              <Button onClick={() => setIsAddModuloOpen(false)}>
                Cancelar
              </Button>
            </ModalActions>
          </Modal.Actions>
        </Modal>

        <Modal open={isAddLiveModalOpen} onClose={handleCloseAddLiveModal}>
          <Modal.Header>Adicionar live</Modal.Header>
          <Modal.Content>
            <AddModuloModalContainer>
              <div>
                <label>Descrição: </label>
                <input
                  placeholder="Descrição"
                  onChange={evt => setAddLiveDescricao(evt.currentTarget.value)}
                />
              </div>
              <div>
                <label>Link: </label>
                <input
                  placeholder="Link"
                  onChange={evt => setAddLiveLink(evt.currentTarget.value)}
                />
              </div>
              <div>
                <label>Data: </label>
                <input
                  type="datetime-local"
                  placeholder="Data"
                  onChange={evt =>
                    setAddLiveDate(formatDateTime(evt.currentTarget.value))
                  }
                />
              </div>
              <div>
                <label>Tipo: </label>
                <select
                  id={"tipo"}
                  onChange={evt => setAddLiveTipo(evt.currentTarget.value)}
                >
                  <option value={"youtube_live"}>youtube_live</option>
                  <option value={"youtube_lives"}>youtube_lives</option>
                </select>
              </div>
            </AddModuloModalContainer>
          </Modal.Content>
          <Modal.Actions>
            <ModalActions>
              <Button positive onClick={() => handleAddLive()}>
                Adicionar Live
              </Button>
              <Button onClick={handleCloseAddLiveModal}>Cancelar</Button>
            </ModalActions>
          </Modal.Actions>
        </Modal>
      </Container>
    </>
  );
};
